export type ImportFileResult =
  | { ok: true; bundle: { name?: unknown; applications?: unknown } }
  | { ok: false; error: string };

/**
 * Reads the text of a file chosen for Import. Valid JSON that is not an
 * object (null, a number, a list) is refused here, because the import
 * screen reads fields of it before the server sees it.
 */
export function readImportFile(text: string): ImportFileResult {
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return { ok: false, error: "The file is not valid JSON" };
  }
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
    return { ok: false, error: "The file is not a tutor version export" };
  }
  return { ok: true, bundle: parsed };
}
